var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.numberOfSlides > 5)?_c('div',{staticClass:"flex items-center"},_vm._l((5),function(n){return _c('span',{staticClass:"dot",class:{
      'active-dot': _vm.activeDot(n - 1, _vm.currentPage, _vm.numberOfSlides),
    }})}),0):_c('div',{staticClass:"flex items-center"},_vm._l((_vm.numberOfSlides),function(n){return _c('span',{staticClass:"dot",class:{
      'active-dot': n - 1 === _vm.currentPage,
    }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }